var _a;
import { WebSocket } from "ws";
// @ts-ignore for WebSocketStream polyfill
(_a = globalThis.WebSocket) !== null && _a !== void 0 ? _a : (globalThis.WebSocket = WebSocket);
export * from "../ws.ts";
//# sourceMappingURL=node.js.map